import React, { Component, Fragment } from 'react'
import PropTypes from "prop-types"

class ProductList extends Component {
  static propTypes = {
    data: PropTypes.object,
    claim_id: PropTypes.string
  }
  
  static defaultProps = {
    data: {},
    claim_id: ''
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  renderProduct = () => {
    return this.props.data.productList.map((item, index) => (
      <div className="row mb-2" key={index}>
        <div className="col-sm-4">
          <input disabled type="text" className="form-control" name="productname" value={item.item_description} />
        </div>
        <div className="col-sm-2">
          <input disabled type="text" className="form-control" name="itemReff" value={item.item_reff} />
        </div>
        <div className="col-sm-2">
          <input disabled type="text" className="form-control" name="itemBudget" value={ item.item_budget ? item.item_budget.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2, }) : 0 } />
        </div>
        <div className="col-sm-2">
          <input type="text" disabled className="form-control" name="itemActual" value={ item.item_actual ? item.item_actual.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2, }) : 0 } placeholder="actual" />
        </div>
      </div>
    ));
  };

  render() {
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header bg-light font-size-title font-weight-bold">Products</div>
              <div className="multi-collapse show" id="multiCollapseExample2">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Product Description</label>
                      <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Product Reff</label>
                      <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Product Budget</label>
                      <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Actual</label>
                      {this.renderProduct()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default ProductList